// OverlayState — in-memory truth des Admin-Overlay-Stacks. Schnitt 4 (gesliced).
// 4a-1: Auswahl (aktives Overlay). 4a-2: Editor-Registry (ref → { overlay, initialBounds, ctx }).
// Geplant: Datenmodell + one-way (4b/4c). Kein DOM, keine Karte, kein AJAX — reiner Zustand.
//
// Eintrag-Konvention (wie im Legacy beibehalten): ein platzierter Overlay hat einen Eintrag mit
// .overlay (Editor-Instanz). Entfernen setzt den Eintrag auf null (Schlüssel bleibt) — rekey löscht
// den Altschlüssel. Iteration/Lookups filtern konsequent gegen null + fehlendes .overlay.

export function createOverlayState() {
    let activeId = null;          // ref des aktuell ausgewählten Overlays (oder null)
    const entries = {};           // ref → { overlay, initialBounds, ctx } | null

    function get(id) { return entries[id]; }                              // Eintrag oder null/undefined
    function getEditor(id) { const e = entries[id]; return e ? e.overlay : null; }

    return {
        // --- Auswahl ---
        getActiveId: function () { return activeId; },
        setActiveId: function (id) { activeId = id; },
        clearActive: function () { activeId = null; },
        getActiveEditor: function () { return getEditor(activeId); },

        // --- Editor-Registry ---
        get: get,
        getEditor: getEditor,
        setEntry: function (id, entry) { entries[id] = entry; },          // addOverlay (Objekt) / remove (null)
        // Iteriert NUR platzierte Overlays (Eintrag vorhanden + .overlay): cb(editor, ref).
        forEachEditor: function (cb) {
            for (var k in entries) {
                if (entries[k] && entries[k].overlay) { cb(entries[k].overlay, k); }
            }
        },
        // m->o-Migration: Registry-Eintrag + Editor-Closure-Ref (ctx.id) + ggf. Auswahl umschlüsseln.
        rekey: function (oldRef, newRef) {
            if (entries[oldRef] !== undefined) {
                entries[newRef] = entries[oldRef];
                delete entries[oldRef];
                if (entries[newRef] && entries[newRef].ctx) { entries[newRef].ctx.id = newRef; }
            }
            if (activeId === oldRef) { activeId = newRef; }
        }
    };
}
